import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { Avatar, AvatarFallback } from "../../../components/Avatar";
import { brand } from "../../../theme/theme";
import { getAvatarImageUrl } from "../../../utils/avatarUtils";

/** Cliente al que se va a enlazar la conexión, en solo lectura y con el aspecto de los selectores. */
export function ConnectingClientField({ client }) {
  const theme = useTheme();
  const name = client.name || "";

  return (
    <Box>
      <Typography variant="body2" sx={{ marginBottom: 1, fontWeight: 500 }}>
        Cliente:
      </Typography>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          px: 1.5,
          py: 1,
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: "8px",
          backgroundColor: theme.palette.action.hover,
          fontSize: "0.875rem",
          fontWeight: 600,
        }}
      >
        <Avatar
          sx={{ width: "24px", height: "24px", flexShrink: 0 }}
          src={getAvatarImageUrl(client.logo) || undefined}
        >
          <AvatarFallback
            sx={{ backgroundColor: brand.avatar, color: "#fff", fontSize: "0.625rem", fontWeight: 600 }}
          >
            {name
              .split(" ")
              .map((part) => part[0])
              .join("")}
          </AvatarFallback>
        </Avatar>
        <Box component="span" sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          {name}
        </Box>
      </Box>
    </Box>
  );
}

ConnectingClientField.propTypes = {
  client: PropTypes.shape({
    name: PropTypes.string,
    logo: PropTypes.string,
  }).isRequired,
};
